import React from 'react';
import docs from '../docs/Curriculum-Vitae.pdf';
import { Helmet } from 'react-helmet';

function AboutMe() {

    return (
        <React.Fragment>
            <Helmet>
                <title>Dev Grimaldo | About Me</title>
                <meta name="description" content="Welcome to my portfolio, I am a frontend web developer"></meta>
            </Helmet>
            <section className="AboutMe ">

                <h2 className="">Frontend Developer</h2>
                <div className='folder-porfolio'>
                    <h1 className="">Brandon James Grimaldo Moscote</h1>
                    <p>
                        Hello, I am a frontend web developer passionate about technology, I am a self-taught person,
                        I always like to be able to learn new things and be aware of new trends in the field of web development.
                    </p>
                    <p >
                        Welcome to my portfolio, where you can see a variety of web projects,
                        as a frontend web developer, I develop multiple web solutions using different
                        tools demanded in the labor market, creating modern web pages with responsive design,
                        professional SEO, 2D and 3D animations.
                    </p>
                    <p>
                        Before specializing as a web developer, I started developing desktop applications using java,
                        c# and using relational databases, if you want you can also see some of my old desktop application,
                        database and video game projects.
                    </p>

                    <div className='CV'>
                        <a href={docs} download="Curriculum-Vitae.pdf" rel='noreferrer'>
                            <button className="animateButton"> <p>Curriculum PDF </p> </button>
                        </a>
                        <a href="https://www.canva.com/design/DAFEABlV388/zyBlJUhMWQYOKARXuNyQJw/view?website#4" target="_blank" rel="noreferrer">
                            <button className="animateButton"> <p>Curriculum WEB </p></button>

                        </a>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
export default AboutMe;